export const ROUTES = {
  findJobs: '/jobs/find',
  searchAi: '/jobs/search/ki',
  searchAiLanding: '/jobs/search/ki/start',
  myJobs: '/jobs/my-jobs',
  myJobsSearchAlerts: '/jobs/my-jobs?active_view=SEARCH_ALERTS',
  jobDetails: '/jobs/:slug',
  jobContacts: '/jobs/:slug/contacts',
  search: '/jobs/search',
  searchId: '/jobs/search/:id',
  searchAlertEmailSubscribe: '/jobs/search/confirm/:token',
  searchAlertEmailUnsubscribe: '/jobs/search/unsubscribe/:token',

  // External (jobs-frontend)
  jobs: '/jobs',

  // External (Crate)
  jobseekerCriteria: '/jobseeker-criteria',
  jobseekerCriteriaSalary: '/jobseeker-criteria/salary',
  privacy: '/privacy',
  profile: '/profile',
  signup: '/signup',
  terms: '/terms',
  updateProfileWithCv: '/profile/my_profile/cv-update/edit',
};

export const XING_PRIVACY_LINK_DE =
  'https://privacy.xing.com/de/datenschutzerklaerung';

export const XING_PRIVACY_LINK_EN =
  'https://privacy.xing.com/en/privacy-policy';
